/** In-app opens of the public profile should not fire Premium scan WhatsApp/SMS alerts. */

export const SKIP_SCAN_ALERT_STATE = { skipScanAlert: true };

export function navigateToPublicProfile(navigate, qrId, { review = true } = {}) {
  if (!qrId || !navigate) return;
  navigate(`/${String(qrId).toUpperCase()}/public`, {
    state: review ? SKIP_SCAN_ALERT_STATE : undefined,
  });
}

export function shouldSkipScanAlert(locationState) {
  return Boolean(locationState?.skipScanAlert || locationState?.fromApp || locationState?.ownerDashboard);
}
